define.alias("shared/utils/array-filters/get-sum-of-extracted-values", "preview-grid/utils/array-filters/get-sum-of-extracted-values");